import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';

const FourOhFour = () => {
  return (
    <>
      <Helmet>
        <title>404 | Mirae</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          '@supports (height: 100dvh)': {
            minHeight: '100dvh',
          },
          flexDirection: 'column',
          padding: 5,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: { md: '300px', xs: '60px', sm: '120px' } }} color="#9B9A7C">
          404
        </Typography>
        <Typography variant="h4">Something went wrong</Typography>
        <Typography variant="body1" sx={{ mt: 1, textAlign: 'center', fontWeight: 500 }}>
          The page you are looking for was moved, removed, renamed or might never existed!
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2, height: '65px', borderRadius: '55px', textTransform: 'none' }}
          href="/"
          color="primary"
        >
          Back to Home
        </Button>
      </Box>
    </>
  );
};

export default FourOhFour;
